import { Button } from '@planuze/ui';
import { usePlansContent } from '../../content/sections/plans.js';
import { BulkSelectionBar } from '../bulk-selection-bar.js';

interface Props {
  readonly selectedCount: number;
  readonly busy: boolean;
  readonly onArchive: () => void;
  readonly onClear: () => void;
}

export function TargetedPlanBulkBar({ selectedCount, busy, onArchive, onClear }: Props) {
  const copy = usePlansContent().targetedSection;
  if (selectedCount === 0) return null;
  return (
    <BulkSelectionBar
      selectedLabel={copy.bulkSelected(selectedCount)}
      clearLabel={copy.bulkClear}
      busy={busy}
      onClear={onClear}
    >
      <Button size="sm" variant="destructive" disabled={busy} onClick={onArchive}>
        {copy.bulkArchive}
      </Button>
    </BulkSelectionBar>
  );
}
